import React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { Field, makeStyles, Textarea } from "@fluentui/react-components";
import EditorFluent9 from "../editor/EditorFluent9";
import { ConfigurationService } from "../../../services/ConfigurationService";

// Fix: mobile webviews don't render the blinking caret inside textareas
// within a fixed-position overlay. A compositing layer forces proper rendering.
// caret-color ensures the cursor is painted even when the field is empty.
const useStyles = makeStyles({
    textarea: {
        "& textarea": {
            "-webkit-transform": "translateZ(0)",
            transform: "translateZ(0)",
            "-webkit-appearance": "none",
            "caret-color": "auto",
        },
    },
});

interface RemarksFluent9Props extends LocalizeContextProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    required?: boolean;
    isNL1221Supported: boolean;
    configService?: ConfigurationService;
    testid?: string;
}

const RemarksFluent9: React.FC<RemarksFluent9Props> = (props) => {
    const testid = props.testid ?? "remarks-fluent9";
    const styles = useStyles();

    return (
        <div className="newforma-remarksFluent9">
            <Field
                label={props.translate("APP.FILE_TRANSFER.REMARKS_LABEL") as string}
                required={props.required ?? false}
                data-testid={`${testid}-field`}
            >
                {props.isNL1221Supported ? (
                    <EditorFluent9
                        value={props.value}
                        onRemarksUpdate={(content) => props.onChange(content ?? "")}
                        configService={props.configService}
                        isFiling={props.disabled ?? false}
                    />
                ) : (
                    <Textarea
                        className={styles.textarea}
                        data-testid={`${testid}-textarea`}
                        value={props.value}
                        onChange={(_e, data) => props.onChange(data.value)}
                        disabled={props.disabled}
                        resize="vertical"
                        rows={5}
                        maxLength={65000}
                    />
                )}
            </Field>
        </div>
    );
};

export default withLocalize(RemarksFluent9);
